import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import { CenteredDiv } from '../styles/commonstyles';
const ErrorMessage = styled.div `
  font-weight: 400;
  font-size: 2vw;
  opacity: 0.8;
`;
const ErrorSubMessage = styled.div `
  padding-top: 0.5vw;
  font-size: 1.4vw;
  opacity: 0.5;
`;
const ClearCacheButton = styled.button `
  margin-top: 2vw;
  padding: 0.8vw 2vw;
  font-size: 1vw;
  border-radius: 0.4vw;
  border: none;
  background: linear-gradient(180deg, #1d7ff3 0%, #113d7d 100%);
  color: white;
  cursor: pointer;
`;
const Error = ({ message, subMessage, showClearCache = false, onClearCache, errorCode, }) => {
    const { t } = useTranslation();
    // If message is a translation key, localize it and interpolate errorCode if present
    const localizedMessage = message && message.startsWith('common.error.')
        ? t(message, errorCode ? { errorCode } : undefined)
        : message || t('common.error.try-again-text');
    return (_jsxs(CenteredDiv, { children: [_jsx("img", { src: require('../../assets/images/cisco_spaces_logo.png'), alt: "Cisco Spaces logo" }), _jsx("br", {}), _jsx(ErrorMessage, { children: localizedMessage }), _jsx(ErrorSubMessage, { children: subMessage || t('common.error.try-again-support-text') }), showClearCache && onClearCache && (_jsx(ClearCacheButton, Object.assign({ onClick: onClearCache }, { children: t('common.error.clear-cache-retry', 'Clear Device Cache & Retry') })))] }));
};
export default Error;
